import { render, staticRenderFns } from "./SonsByIdSpecimenItem.vue?vue&type=template&id=6db1ca6e"
import script from "./SonsByIdSpecimenItem.vue?vue&type=script&lang=js"
export * from "./SonsByIdSpecimenItem.vue?vue&type=script&lang=js"
import style0 from "./SonsByIdSpecimenItem.vue?vue&type=style&index=0&id=6db1ca6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports